/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ countdown: NonNullable<unknown> }} Game_Resets_InInputs */

const bn_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countdown} (UTC) এ পুনরায় সেট করে।`)
};

const de_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wird in ${i?.countdown} (UTC) zurückgesetzt.`)
};

const el_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Επαναφέρεται σε ${i?.countdown} (UTC).`)
};

const en_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resets in ${i?.countdown} (UTC).`)
};

const es_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se reinicia en ${i?.countdown} (UTC).`)
};

const fr_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Réinitialisation dans ${i?.countdown} (UTC).`)
};

const hi_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countdown} (UTC) में रीसेट होता है।`)
};

const hu_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Visszaállítás ${i?.countdown} (UTC) múlva.`)
};

const id_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Direset dalam ${i?.countdown} (UTC).`)
};

const it_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Si reimposta tra ${i?.countdown} (UTC).`)
};

const ja_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countdown} (UTC) にリセットされます。`)
};

const ko_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countdown}(UTC)에 재설정됩니다.`)
};

const nl_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resetten over ${i?.countdown} (UTC).`)
};

const pl_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resetuje się w ${i?.countdown} (UTC).`)
};

const pt_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reinicia em ${i?.countdown} (UTC).`)
};

const ru_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сбрасывается в ${i?.countdown} (UTC).`)
};

const sv_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Återställs i ${i?.countdown} (UTC).`)
};

const tr_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countdown} (UTC) tarihinde sıfırlanır.`)
};

const uk_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Скидання через ${i?.countdown} (UTC).`)
};

const vi_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đặt lại sau ${i?.countdown} (UTC).`)
};

const zh_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在 ${i?.countdown} (UTC) 重置。`)
};

const zh_hant_game_resets_in = /** @type {(inputs: Game_Resets_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在 ${i?.countdown} (UTC) 重設。`)
};

/**
* | output |
* | --- |
* | "Resets in {countdown} (UTC)." |
*
* @param {Game_Resets_InInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_resets_in = /** @type {((inputs: Game_Resets_InInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Resets_InInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_resets_in(inputs)
	if (locale === "de") return de_game_resets_in(inputs)
	if (locale === "el") return el_game_resets_in(inputs)
	if (locale === "en") return en_game_resets_in(inputs)
	if (locale === "es") return es_game_resets_in(inputs)
	if (locale === "fr") return fr_game_resets_in(inputs)
	if (locale === "hi") return hi_game_resets_in(inputs)
	if (locale === "hu") return hu_game_resets_in(inputs)
	if (locale === "id") return id_game_resets_in(inputs)
	if (locale === "it") return it_game_resets_in(inputs)
	if (locale === "ja") return ja_game_resets_in(inputs)
	if (locale === "ko") return ko_game_resets_in(inputs)
	if (locale === "nl") return nl_game_resets_in(inputs)
	if (locale === "pl") return pl_game_resets_in(inputs)
	if (locale === "pt") return pt_game_resets_in(inputs)
	if (locale === "ru") return ru_game_resets_in(inputs)
	if (locale === "sv") return sv_game_resets_in(inputs)
	if (locale === "tr") return tr_game_resets_in(inputs)
	if (locale === "uk") return uk_game_resets_in(inputs)
	if (locale === "vi") return vi_game_resets_in(inputs)
	if (locale === "zh") return zh_game_resets_in(inputs)
	return zh_hant_game_resets_in(inputs)
});